import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
export const TOKEN_EMBED_KEY = 'template-variable';
const SILENT = 'silent';
const tokenText = (label)=>"{{".concat(label, "}}");
const USER = 'user';
function boundsAt(quill, index, length) {
    try {
        return quill.getBounds(index, length);
    } catch (unused) {
        // WHY: getBounds relies on layout APIs jsdom does not implement — callers fall back to the editor element.
        return null;
    }
}
export function tokenEmbedLabel(insert) {
    var _insert_TOKEN_EMBED_KEY_label, _insert_TOKEN_EMBED_KEY;
    if (insert == null || typeof insert !== 'object' || !(TOKEN_EMBED_KEY in insert)) return null;
    const label = (_insert_TOKEN_EMBED_KEY = insert[TOKEN_EMBED_KEY]) === null || _insert_TOKEN_EMBED_KEY === void 0 ? void 0 : (_insert_TOKEN_EMBED_KEY_label = _insert_TOKEN_EMBED_KEY.label) === null || _insert_TOKEN_EMBED_KEY_label === void 0 ? void 0 : _insert_TOKEN_EMBED_KEY_label.trim();
    return label ? label : null;
}
export function stripTokenEmbeds(quill) {
    var _ref;
    var _quill_getContents;
    const ops = (_ref = (_quill_getContents = quill.getContents()) === null || _quill_getContents === void 0 ? void 0 : _quill_getContents.ops) !== null && _ref !== void 0 ? _ref : [];
    if (!ops.some((op)=>tokenEmbedLabel(op.insert) != null)) return;
    quill.setContents({
        ops: ops.map((op)=>{
            const label = tokenEmbedLabel(op.insert);
            return label == null ? op : _object_spread_props(_object_spread({}, op), {
                insert: tokenText(label)
            });
        })
    }, SILENT);
}
export function clickHitsTokenText(args) {
    const { quill, start, length, clickX, clickY } = args;
    for(let offset = 0; offset < length; offset++){
        const bounds = boundsAt(quill, start + offset, 1);
        if (!bounds) continue;
        const withinX = clickX >= bounds.left && clickX <= bounds.left + bounds.width;
        const withinY = clickY >= bounds.top && clickY <= bounds.top + bounds.height;
        if (withinX && withinY) return true;
    }
    return false;
}
export function createTokenBoundsAnchor(args) {
    const { editorEl, quill, index, length } = args;
    const bounds = boundsAt(quill, index, length);
    const editorParent = editorEl.parentElement;
    if (!bounds || !editorParent) return null;
    const editorRect = editorEl.getBoundingClientRect();
    const parentRect = editorParent.getBoundingClientRect();
    const anchor = document.createElement('span');
    anchor.style.position = 'absolute';
    anchor.style.left = "".concat(bounds.left + (editorRect.left - parentRect.left), "px");
    anchor.style.top = "".concat(bounds.top + (editorRect.top - parentRect.top), "px");
    anchor.style.width = '0';
    anchor.style.height = "".concat(bounds.height, "px");
    anchor.style.pointerEvents = 'none';
    // WHY: only positioning we introduced gets reverted on cleanup — never clobber a position the page already set.
    const previousParentPosition = editorParent.style.position;
    const didSetParentPosition = previousParentPosition === '';
    if (didSetParentPosition) editorParent.style.position = 'relative';
    editorParent.appendChild(anchor);
    return {
        anchor,
        cleanup: ()=>{
            anchor.remove();
            if (didSetParentPosition) editorParent.style.position = previousParentPosition;
        }
    };
}
export function insertTokenIntoQuill(args) {
    const { quill, label } = args;
    const range = quill.getSelection(true);
    if (!range) return null;
    if (range.length > 0) quill.deleteText(range.index, range.length, USER);
    const inserted = tokenText(label);
    quill.insertText(range.index, inserted, USER);
    quill.setSelection(range.index + inserted.length, 0, SILENT);
    return {
        index: range.index,
        length: inserted.length
    };
}
export function restoreTriggerBraces(quill, at) {
    quill.insertText(at, '{{', USER);
    quill.setSelection(at + 2, 0, SILENT);
}
